export const initial = {
  zoomStep: 10,
  maxZoom: 300,
  minZoom: 10,
  defaultZoom: 100,
  padding: {
    y: {
      mobile: 16 * 2,
      desktop: 30 * 2,
    },
    x: {
      mobile: 16 * 2,
      desktop: 60 * 2,
    },
  },
} as const;
